import React from 'react';
var useRef = React.useRef;
export function useComponentWillMount(fn) {
    var willMount = useRef(true);
    if (willMount.current) {
        return fn();
    }
    willMount.current = false;
}
